"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.join");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _invariant = _interopRequireDefault(require("invariant"));

/**
 * Vrati query part pre vyhladavanie textu bez diakritiky s ciastocnou zhodou aspon jedneho chunku v multilang fieldoch.
 *
 * Pokial `value` obsahuje medzery bude rozdelene na chunky. K zhode dojde v pripade, ze cielovy
 * text obsahuje aspon jeden z chunkov. V cielovych textoch sa hlada ciastocna zhoda chunku.
 *
 * Priklad: 'krá dum' =$search=> 'kraso videna' | 'krasavice nase' | 'plny dum' | 'dumxxx'
 *
 * Je vhodne pri vyhladavani v ciselnikoch.
 *
 * @param {string} fieldName
 * @param {string} value
 * @param {string} language
 * @param {Object} [opts = {}]
 * @param {string} [opts.languageField = 'language']
 * @param {string} [opts.textField = 'text']
 *
 * @returns {Object}
 */
var textElementSearchToQuery = function textElementSearchToQuery(fieldName, value) {
  var parts = fieldName.split('.');
  (0, _invariant.default)(parts.length > 1, "At least one sub field have to be defined. If you don't have sub fields to match, please consider to use 'textContainsToQuery'.");
  var innerField = parts.pop();
  return value === undefined ? undefined : (0, _defineProperty2.default)({}, parts.join('.'), {
    $elemMatch: (0, _defineProperty2.default)({}, innerField, {
      $search: value
    })
  });
};

var _default = textElementSearchToQuery;
exports.default = _default;